import { baseApi } from '../../../platform/api/base-api'
import {
  guideSchema,
  guideStatusSchema,
  guideTargetSchema,
} from './guide-contracts'
import type { Guide } from '../domain/guide'
import type { GuideTarget } from '../../../shared/routing/guide-target'
const path = '/engagement/v3/guide'
export const guideApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    guideStatus: b.query<
      { available: boolean; revisionId: string | null },
      string
    >({
      query: () => ({
        url: `${path}/status`,
        cache: 'no-store',
        timeout: 5000,
      }),
      transformResponse: (value) => guideStatusSchema.parse(value),
      keepUnusedDataFor: 0,
    }),
    guide: b.query<Guide, string>({
      query: () => ({
        url: path,
        params: {
          platform:
            typeof matchMedia === 'function' &&
            matchMedia('(display-mode: standalone)').matches
              ? 'pwa'
              : 'web',
        },
        cache: 'no-store',
        timeout: 10000,
      }),
      transformResponse: (value) => guideSchema.parse(value),
      keepUnusedDataFor: 0,
    }),
    guideLegacy: b.query<GuideTarget, { scope: string; slug: string }>({
      query: ({ slug }) => ({
        url: `${path}/legacy/${encodeURIComponent(slug)}`,
        cache: 'no-store',
        timeout: 5000,
      }),
      transformResponse: (value) => guideTargetSchema.parse(value),
      keepUnusedDataFor: 0,
    }),
  }),
})
export const { useGuideStatusQuery, useGuideQuery, useGuideLegacyQuery } =
  guideApi
